import { render, staticRenderFns } from "./MyInvoice.vue?vue&type=template&id=040f498e&scoped=true"
import script from "./MyInvoice.vue?vue&type=script&lang=js"
export * from "./MyInvoice.vue?vue&type=script&lang=js"
import style0 from "./MyInvoice.vue?vue&type=style&index=0&id=040f498e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f498e",
  null
  
)

export default component.exports